import { render, staticRenderFns } from "./omsqueuelog.vue?vue&type=template&id=78f3336b"
import script from "./omsqueuelog.vue?vue&type=script&lang=js"
export * from "./omsqueuelog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports